import { validateTokenForOrder } from 'common/services/http.service';
import { fetchLead, removeUserSessionData, showServiceError, navigateTo, updateParamsToTmo, isSingleUpgradeOrShiftingJourney, getFromSessionStorage } from 'common/utils/app.utils';
import { History } from 'home/view/check-feasibility/comp-generator/common-interface';
import { ROUTES } from 'common/constants/app.constants';
import appConfig from 'config/config';
import { IGetLeadRequest, ILeadRequest } from './lead.interface';
import { createLead, fetchAOIAccountsAsync, fetchLeadToken } from './lead.service';
import { saveLead, saveToken, saveAuthorizedSignatory, saveLob, updateLeadAnalytics, saveCartIdFromParams, saveSummaryToken, saveSelectedProductType } from './lead.util';
import { isUserTypeIsKAM } from 'dedicated/components/plan-and-configuration/configure-plan-pricing-constant';
import axios from 'common/interceptor/app.interceptor';
import { MULTI_SITE_MODULE_ID } from 'home/view/manage-feasibility/constants';
import { MODULE_ID, SUMMARY_AUTHORIZATION_HEADER } from 'home/common/constants/constants';

export const handleLeadResponse = (rawResponse: any) => {
  saveToken(rawResponse);
  saveAuthorizedSignatory(rawResponse);
  saveLob(rawResponse);

  // update lead analytics on success
  updateLeadAnalytics(rawResponse);
};

const fetchAndSaveLead = async (onSuccess: Function) => {
  try {
    const response = await fetchLead();

    if (!response) {
      throw new Error('fetch lead failed...');
    }

    saveLead(response?.data?.result);

    if (!isUserTypeIsKAM() && !isSingleUpgradeOrShiftingJourney()) {
      // PnQ lead get doesn't have productType.
      saveSelectedProductType(response?.data?.result?.serviceType);
      updateParamsToTmo(response?.data?.result);
    }
    onSuccess?.(response);
  } catch (e) {
    showServiceError({
      show: true,
      data: null,
      redirect: false
    });
  }
};

export const fetchLeadHandler = (rawRequest?: IGetLeadRequest) => {
  return new Promise((onSuccess, onError) => {
    fetchLeadToken(rawRequest).then(
      async (rawResponse: any) => {
        saveToken(rawResponse);
        saveCartIdFromParams();

        // fetch/save lead
        fetchAndSaveLead(onSuccess);
      },
      (error: any) => {
        onError?.(error);
        navigateTo?.(appConfig?.selfcareLoginPageBaseUrl);
      }
    );
  });
};

export const fetchAOIAccounts = (params: any) => {
  return new Promise((onSuccess, onReject) => {
    fetchAOIAccountsAsync(params).then(
      async (rawResponse: any) => {
        onSuccess?.(rawResponse);
      },
      (error: any) => {
        onReject?.(error);
        showServiceError({
          show: true,
          data: error?.response?.data?.errorMsg ?? null,
          redirect: false
        });
      }
    );
  });
};

export const createNewLeadHandler = (request?: ILeadRequest) => {
  return new Promise((onSuccess, onReject) => {
    createLead(request).then(
      async (rawResponse: any) => {
        saveToken(rawResponse);
        saveAuthorizedSignatory(rawResponse);
        saveLob(rawResponse);

        // update lead analytics on success
        updateLeadAnalytics(rawResponse);

        // fetch/save lead
        fetchAndSaveLead(onSuccess);
      },
      (error: any) => {
        onReject?.(error);
        showServiceError({
          show: true,
          data: error?.response?.data?.errorMsg ?? null,
          redirect: false
        });
      }
    );
  });
};

export const createNewLeadHandlerAOI = (request?: ILeadRequest) => {
  return new Promise((onSuccess, onReject) => {
    createLead(request).then(
      async (rawResponse: any) => {
        saveToken(rawResponse);
        saveAuthorizedSignatory(rawResponse);
        // saveLob(rawResponse);

        // update lead analytics on success
        updateLeadAnalytics(rawResponse);

        // fetch/save lead
        fetchAndSaveLead(onSuccess);
      },
      (error: any) => {
        onReject?.(error);
        showServiceError({
          show: true,
          data: error?.response?.data?.errorMsg ?? null,
          redirect: false
        });
      }
    );
  });
};

export const createUpdateKdmDetailsHandlerAOI = (payload: any) => {
  return axios({
    method: 'post',
    url: ':10.241.150.189/b2b-acquisition-kyc/b2b-acquisition-kyc/order/update',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    }
  });
};

export const validateAndFetchOrder = (type: string, orderId: string, authToken: string, history: History) => {
  removeUserSessionData();
  return new Promise((onSuccess, onError) => {
    validateTokenForOrder(authToken, type, orderId).then(
      (rawResponse: any) => {
        saveSummaryToken(authToken);
        onSuccess?.(rawResponse);
      },
      (err) => {
        onError?.(err);
        history?.push(ROUTES.B2B_FAILURE);
      }
    );
  });
};
